import { createApp } from "vue";
import { setupI18n } from "./i18n";
import App from "./App.vue";

import { MotionPlugin } from "@vueuse/motion";
import VueSvgInlinePlugin from "vue-svg-inline-plugin";
import FloatingVue from "floating-vue";
import { plugin as FormkitPlugin, defaultConfig } from "@formkit/vue";
import { generateClasses } from "@formkit/themes";
import theme from "./formkit-theme";
import "./assets/style.scss";
import "floating-vue/dist/style.css";
import { isValidPhoneNumber } from "@/form/validation/phoneNumber";
import { canUseLocalstorage } from "@/util/localstorage";
import { en, nb } from "@formkit/i18n";

const i18n = setupI18n();

const useLocalstorage = canUseLocalstorage();

const app = createApp(App);
app.use(i18n);
app.use(MotionPlugin);
app.use(FloatingVue);
app.use(
  FormkitPlugin,
  defaultConfig({
    rules: {
      phone: isValidPhoneNumber,
    },
    config: {
      classes: generateClasses(theme),
    },
    locales: { en, nb },
    // Define the active locale
    locale: "en",
  })
);
app.use(VueSvgInlinePlugin, {
  cache: {
    persistent: useLocalstorage,
    removeRevisions: useLocalstorage,
  },
});

app.mount("#app");
